import { AuthProvider } from './lib/auth';
import { AppRoutes } from './routes';

/**
 * Raiz da aplicacao: sessao mais tabela de rotas.
 *
 * O Router fica em main.tsx, e nao aqui, para que este componente possa ser
 * montado dentro de um MemoryRouter em teste sem arrastar o historico do
 * navegador junto. O AuthProvider fica DENTRO do Router porque o porteiro de
 * rota precisa de `useLocation` para lembrar de onde a pessoa veio.
 */
export function App(): JSX.Element {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;
